import EventsSchedule from '../../components/event-schedule/event-schedule';
import Calendar from '../../components/calendar/calendar';
import './schedule.scss';

    const Schedule = () => (
  <div className="schedule-page">
    <section className="schedule-hero">
      <div className="schedule-hero__overlay" />
      <div className="schedule-hero__content">
        <h1>Schedule</h1>
        <p>Upcoming Meetings and Events</p>
      </div>
    </section>

    <section className="schedule-details">
      <div className="schedule-details__inner">

        <article className="schedule-details__section">
          <h2 className="schedule-details__section-title">Calendar</h2>
          <p className="schedule-details__section-description">MSIA Only</p>
          <Calendar showAll />
        </article>

        <br/>
        <br/>

        <article className="schedule-details__section">
          <h2 className="schedule-details__section-title">Events</h2>
          <p className="schedule-details__section-description">All Events</p>
          <EventsSchedule showAll enableImageModal preferFullImagePreview />
        </article>
      </div>
    </section>
  </div>
);

export default Schedule;
